module.exports = __webpack_public_path__ + "media/dobry_wzor/dobry-wzor-laureat@2x-1cef4428.png";